// extracted by mini-css-extract-plugin
module.exports = {"textStyle":"labelwithsvg_textStyle__1igGA","flexStyle":"labelwithsvg_flexStyle__31gvj","disable":"labelwithsvg_disable__3nh8b"};